<div class="login-logo-container container align-items-center justify-content-center">
    <div class="slingmax-logo login-logo"></div>
</div>
